import { Link } from "react-router-dom";
import { formatDateRange, joinStyles } from "@/lib/format";

export const scrollToId = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

export const FestivalSidebar = ({ festival, ctaLabel = "Learn More", targetId = "festival", ctaTestId = "festival-learn-more-button" }) => (
  <aside className="lg:sticky lg:top-[120px] bg-white border border-[#E6E6E6] rounded-2xl p-5 md:p-6 shadow-[0_2px_12px_rgba(0,0,0,0.03)] df-fade-up" data-testid="festival-sidebar">
    <h2 className="text-[16px] 4xl:text-[20px] font-bold leading-tight">{festival.name}</h2>
    <p className="mt-1.5 text-[12px] 4xl:text-[15px] font-semibold text-[#555]">{formatDateRange(festival.start_date, festival.end_date)}</p>
    {festival.location && <p className="text-[12px] 4xl:text-[15px] font-medium text-[#555]">{festival.location}</p>}
    {festival.features_summary && (
      <>
        <p className="mt-5 text-[13px] 4xl:text-[16px] font-bold">Features</p>
        <p className="mt-1 text-[11.5px] 4xl:text-[14px] text-[#555] leading-snug">{festival.features_summary}</p>
      </>
    )}
    {festival.dance_styles?.length > 0 && (
      <>
        <p className="mt-5 text-[13px] 4xl:text-[16px] font-bold">Dance Styles</p>
        <p className="mt-1 text-[11.5px] 4xl:text-[14px] text-[#555] leading-snug">{festival.dance_styles.join(", ")}</p>
      </>
    )}
    <button
      type="button"
      onClick={() => scrollToId(targetId)}
      className="mt-6 w-full rounded-md bg-[#F8D481] hover:bg-[#f3c968] py-3 4xl:py-4 text-[16px] 4xl:text-[19px] font-bold transition-colors"
      data-testid={ctaTestId}
    >
      {ctaLabel}
    </button>
  </aside>
);

export const JoinCard = ({ festival }) => (
  <div className="bg-white border border-[#E6E6E6] rounded-2xl p-5 md:p-7 flex flex-col md:flex-row gap-6 md:gap-10 items-start shadow-[0_2px_12px_rgba(0,0,0,0.03)]" data-testid="festival-join-card">
    <div className="flex-1 min-w-0 order-2 md:order-1">
      <h3 className="text-[16px] lg:text-[19px] font-bold leading-tight">
        <Link to={`/festivals/${festival.id}`} className="hover:underline underline-offset-2" data-testid="join-card-festival-link">
          {festival.name}
        </Link>
      </h3>
      {festival.location && <p className="text-[12px] lg:text-[14px] font-medium text-[#555]">{festival.location}</p>}
      {festival.features_summary && (
        <>
          <p className="mt-5 text-[13px] lg:text-[15px] font-bold">Features</p>
          <p className="mt-1 text-[11.5px] lg:text-[14px] text-[#555]">{festival.features_summary}</p>
        </>
      )}
      {festival.dance_styles?.length > 0 && (
        <>
          <p className="mt-5 text-[13px] lg:text-[15px] font-bold">Dance Styles</p>
          <p className="mt-1 text-[11.5px] lg:text-[14px] text-[#555] leading-snug">{joinStyles(festival.dance_styles)}</p>
        </>
      )}
    </div>
    <div className="w-full md:w-[270px] shrink-0 order-1 md:order-2">
      <div className="aspect-[285/160] rounded-lg bg-[#D9D9D9] overflow-hidden">
        {festival.cover_image_url && <img src={festival.cover_image_url} alt={festival.name} className="w-full h-full object-cover" />}
      </div>
      <button
        type="button"
        onClick={() => scrollToId("passes")}
        className="mt-3 w-full rounded-md bg-[#F8D481] hover:bg-[#f3c968] py-3 text-[16px] font-bold transition-colors"
        data-testid="festival-join-button"
      >
        Join Festival
      </button>
    </div>
  </div>
);
